import $ from 'jquery';
//https://bootstrap-datepicker.readthedocs.io/en/latest/options.html
import datepicker from 'bootstrap-datepicker';
import datepickerIT from '../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.it.js';
import datepickerDE from '../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.de.js';

export default function inputDate() {
  
  let date = new Date();
  let today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  let end = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  
  function eventDateFrom() {
    $('#event-date-from').datepicker({
      format: "dd/mm/yyyy",
      language: "it",
      //startDate: today,
      todayBtn: "linked",
      orientation: "bottom left",
      daysOfWeekHighlighted: "0,6",
      autoclose: true,
      clearBtn: true
    });
    
    if($('#event-date-from').val() == '') {
      $('#event-date-from').datepicker('setDate', today);
    }
  }
  
  function eventDateTo() {
    $('#event-date-to').datepicker({
      format: "dd/mm/yyyy",
      todayBtn: "linked",
      language: "it",
      orientation: "bottom left",
      daysOfWeekHighlighted: "0,6",
      //endDate: "+0d"
      autoclose: true,
      clearBtn: true
    });
  }
  
  $( document ).ready(function() {
    if($('#event-date-from').length > 0) {
      eventDateFrom();
    }
    
    if($('#event-date-to').length > 0) {
      eventDateTo();
    }
  });
}


// WEBPACK FOOTER //
// ./src/assets/js/datepicker.js